import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { getMarginDetails as getMarginDetailsApi } from '../api/marginDetailsApi'
import { HttpResponseStatusCodes } from '../constants'
import { MARGIN_RETRIEVAL_FAILED, TEMPORARILY_UNAVAILABLE } from './constants'

export const GET_MARGIN_DETAILS = 'GET_MARGIN_DETAILS'
export const GET_MARGIN_DETAILS_SUCCESS = 'GET_MARGIN_DETAILS_SUCCESS'
export const GET_MARGIN_DETAILS_FAILURE = 'GET_MARGIN_DETAILS_FAILURE'

export const getMarginDetails = (
  dispatch: Dispatch,
  accountNumber: string,
  acatsControlNumber: string
) => {
  dispatch({ type: GET_MARGIN_DETAILS })
  getMarginDetailsApi(accountNumber, acatsControlNumber)
    .then((response: AxiosResponse) => {
      const marginDetails = response.data
      dispatch({ type: GET_MARGIN_DETAILS_SUCCESS, marginDetails })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      const errorMessage =
        httpResponseStatus &&
        httpResponseStatus >= HttpResponseStatusCodes.InternalServerError
          ? TEMPORARILY_UNAVAILABLE
          : MARGIN_RETRIEVAL_FAILED
      dispatch({ type: GET_MARGIN_DETAILS_FAILURE, errorMessage })
    })
}
